
import * as React from 'react';
import { View } from "react-native";
import { tw } from "@/lib";


export const LineSeparator: React.FunctionComponent = () => {
  return <View style={[tw`mx-[5%] w-[90%] h-[1px] bg-light`]} />;
};
